"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OccupationsContract = void 0;
const core_1 = require("@ts-rest/core");
const occupations_request_1 = require("./occupations.request");
const occupations_response_1 = require("./occupations.response");
const c = (0, core_1.initContract)();
exports.OccupationsContract = c.router({
    listChildrenById: {
        method: 'GET',
        path: '/:occupationId',
        responses: { 200: occupations_response_1.OccupationListChildrenResponseSchema },
        pathParams: occupations_request_1.OccupationIdPathParamsSchema,
    },
    listRoots: {
        method: 'GET',
        path: '/',
        responses: { 200: occupations_response_1.OccupationListRootsResponseSchema },
    },
}, { pathPrefix: '/occupations' });
